'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var Vue = require('vue');

exports.default = Vue.component('input-confirm', {
    props: ['label', 'flip_connotation'],
    data: function data() {
        return {
            state: 'pre'
        };
    },
    computed: {
        connoteCss: function connoteCss() {
            return {
                yes: this.flip_connotation ? 'warning' : 'primary',
                no: this.flip_connotation ? 'primary' : 'warning'
            };
        }
    },
    created: function created() {
        if (!this.$slots.default) {
            this.state = 'prompt';
        }
    },

    methods: {
        prompt: function prompt() {
            this.state = 'prompt';
        },
        complete: function complete(val) {
            this.$emit('submit', val);
            this.$emit(val ? 'ok' : 'cancel');
            this.state = 'pre';
        }
    }
});
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["utils"]) window._kiwi_exports["components"]["utils"] = {};
window._kiwi_exports["components"]["utils"]["InputConfirm"]
window._kiwi_exports.components.utils.InputConfirm = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/utils/InputConfirm.vue
// module id = 1crt
// module chunks = 1